import React from 'react'
import PlanCentralDocs from '../../admin/PlanCentralDocs'
import V3PageBridgeFrame from '../V3PageBridgeFrame'

export default function V3PlanCentralDocsPage() {
  return (
    <V3PageBridgeFrame>
      <PlanCentralDocs />
    </V3PageBridgeFrame>
  )
}
